import { render, staticRenderFns } from "./DubaInterests.vue?vue&type=template&id=43ae8726&scoped=true&"
import script from "./DubaInterests.vue?vue&type=script&lang=js&"
export * from "./DubaInterests.vue?vue&type=script&lang=js&"
import style0 from "./DubaInterests.vue?vue&type=style&index=0&id=43ae8726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae8726",
  null
  
)

export default component.exports